var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('v-icon',_vm._g({class:_vm.iconStyles,domProps:{"textContent":_vm._s(_vm.icon)}},on))]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.allMessages)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }